class DiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = this.dataset.storageKey || 'romy-discount-popup-dismissed';
    this.delay = parseInt(this.dataset.delay, 10) || 5000;
  }

  connectedCallback() {
    this.overlay = this.querySelector('.discount-popup__overlay');
    this.closeButton = this.querySelector('.discount-popup__close');
    this.dismissLink = this.querySelector('.discount-popup__dismiss-link');
    this.hasSuccess = !!this.querySelector('.discount-popup__success');

    this.closeButton?.addEventListener('click', () => this.hide());
    this.dismissLink?.addEventListener('click', () => this.hide());
    this.overlay?.addEventListener('click', () => this.hide());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.hide();
    });

    const alreadyDismissed = window.localStorage.getItem(this.storageKey);

    if (this.hasSuccess) {
      // Just submitted the form and the page reloaded — show the code immediately.
      this.show();
      window.localStorage.setItem(this.storageKey, '1');
      return;
    }

    if (alreadyDismissed) return;

    this.timer = window.setTimeout(() => this.show(), this.delay);
  }

  show() {
    this.style.display = 'block';
    requestAnimationFrame(() => this.classList.add('discount-popup--active'));
    document.body.classList.add('discount-popup-open');
  }

  hide() {
    if (this.timer) window.clearTimeout(this.timer);
    this.classList.remove('discount-popup--active');
    document.body.classList.remove('discount-popup-open');
    window.localStorage.setItem(this.storageKey, '1');
    window.setTimeout(() => {
      this.style.display = 'none';
    }, 300);
  }
}

customElements.define('discount-popup', DiscountPopup);